import { useEffect } from "react";
import useSubscriptions from "./useSubscriptions";
import { getSubscriptionTagsByCategory } from "./getSubscriptionsByCategory";
import { useGetPreferences } from "../../../api/preferences/useGetPreferences";
import { PUB_LANG } from "../../../redux/slices/api/initialisePreferences";

/**
 * When the deep link `?q=<pubId>&subscribe=true` is opened, this hook
 * detects that this publication card matches the pending ID and
 * automatically opens the subscription modal for it.
 *
 * Call this hook inside any publication card component, passing the
 * publication object.
 */
export function useAutoSubscribePublication(publication) {
  const reportLang = useGetPreferences(PUB_LANG);
  const {
    pendingSubscribePubId,
    setPendingSubscribePubId,
    setIsSubscriptionFromPillsBar,
    setSelectedPub,
    setSelectedSubscriptionTags,
    setSelectedLanguages,
    setSubscriptionName,
    setModalShow,
  } = useSubscriptions();

  useEffect(() => {
    if (!pendingSubscribePubId || !publication?.id) return;
    if (String(publication.id) !== String(pendingSubscribePubId)) return;

    setPendingSubscribePubId(null);
    setIsSubscriptionFromPillsBar(false);
    setSelectedPub(publication);
    const tags = Object.values(getSubscriptionTagsByCategory(publication)).flat();
    setSelectedSubscriptionTags(tags);
    setSelectedLanguages(reportLang);
    setSubscriptionName("");
    setModalShow(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingSubscribePubId, publication?.id]);
}
